<template>
  <div>
    <course-buy-desktop v-if="screenType === 'desktop'"></course-buy-desktop>
    <course-buy-mobile v-else></course-buy-mobile>
  </div>
</template>

<script>
import CourseBuyDesktop from "@/components/Pages/Desktop/Dashboard/Courses/CourseBuyDesktop";
import CourseBuyMobile from "@/components/Pages/Mobile/Dashboard/Courses/CourseBuyMobile";

export default {
  name: "CourseBuyMain",
  components: {CourseBuyMobile, CourseBuyDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop',
    }
  },
}
</script>

<style scoped>

</style>